import { useLocation, useNavigate } from "react-router-dom";
import userStorage from "../../utils/userStorage";
import styled from "@emotion/styled";
import { Select, MenuItem, FormControl } from "@mui/material";
import theme from "../../theme";
import { NongCallLogo2 } from "../../assets/images/images";
import {
  DataPieIcon,
  DetectListIcon,
//  DetectPastIcon,
  LogOutIcon,
  MenuButton,
  NoticeIcon,
  SmallAdminIcon,
  SmallNokIcon,
  SmallRealAdminIcon,
  TracktorAndGlassIcon,
  TracktorIcon,
  ShopZoneIcon,
  BigDataIcon,
} from "../../assets/icons/icons";
import { HeaderUser } from "../headerUser";
import { MemberDetail, User } from "../../types/types";
import { useState } from "react";
import { useSystemSetting } from "../../hooks/useSystemSetting";
import { logOut } from "../../api/client";
import { NotificationBadge } from "../common/NotificationBadge";
import UserDetailModal from "../userDetailModal/userDetailModal";
import UserModifyModal from "../userModifyModal/userModifyModal";
import useGetNotice from "../../hooks/useGetNotice";
import { useLocaleWithStorage, Locale, useI18n } from "../../locales";
import { LanguageFlag } from "../../assets/images/languageFlags";

const { sm, md } = theme.screen;

export const MobileNav = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const user = userStorage.get();
  const { locale, setLocale } = useLocaleWithStorage();
  const { t } = useI18n();
  const [idx, setIdx] = useState(0);
  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const systemSetting = useSystemSetting();
  const [detailData, setDetailData] = useState<MemberDetail>();
  const [openModify, setOpenModify] = useState(false);

  const { data: newNoticeData } = useGetNotice(0, 0);

  const navigateTo = (path: string) => {
    navigate(`${path}`);
  };

  const handleClick = () => {
    // 유저이름 클릭시
    if (user) {
      onClickDetail(user);
    }
    return;
  };

  const onClickDetail = (el: User) => {
    setIdx(el.idx);
    setOpen(true);
  };

  const hadleLogout = () => {
    const result = window.confirm(`로그아웃하시겠습니까 ?`);
    if (result) {
      logOut();
      navigate(`/login`, { replace: true });
    } else if (!result) {
      return;
    }
  };

  const handleOnClick = () => {
    setActiveMenu((prev) => !prev);
  };

  const userModalonPressNo = () => {
    setOpen(false);
  };

  const onClickModify = () => {
    setOpen(false);
    setOpenModify(true);
  };

  const onPressNoModify = () => {
    setOpenModify(false);
  };

  return (
    <Wrapper>
      {/* 로고부분 */}
      <LogoWrapper onClick={() => navigateTo("/")}>
        <NongCallLogo2 />
      </LogoWrapper>
      {/* ------- screen sm ~ md ------- */}
      <MenuButtonContainer>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "7px",
            height: "50px",
          }}
        >
          <OptionWrapper>
            {/* 언어 선택 셀렉박스 (모바일) - 사용자 정보 왼쪽 */}
            {false && (
              <LanguageSelectWrapper>
                <LanguageSelectFormControl size="small">
              <LanguageSelectDisplay>
                <LanguageFlag locale={locale} width={16} height={10} />
              </LanguageSelectDisplay>
              <LanguageSelectMUI
                value={locale}
                onChange={(e) => setLocale(e.target.value as Locale)}
                renderValue={() => ""}
                sx={{
                  "& .MuiSelect-select": {
                    padding: "4px 22px 4px 0",
                    fontSize: "11px",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: "14px",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      "& .MuiMenuItem-root": {
                        padding: "8px 14px",
                      },
                    },
                  },
                }}
              >
                <MenuItem value="ko">
                  <MenuItemContent>
                    <LanguageFlag locale="ko" width={16} height={10} />
                    <span>한국어</span>
                  </MenuItemContent>
                </MenuItem>
                <MenuItem value="en">
                  <MenuItemContent>
                    <LanguageFlag locale="en" width={16} height={10} />
                    <span>English</span>
                  </MenuItemContent>
                </MenuItem>
                <MenuItem value="zh">
                  <MenuItemContent>
                    <LanguageFlag locale="zh" width={16} height={10} />
                    <span>中文</span>
                  </MenuItemContent>
                </MenuItem>
                <MenuItem value="ja">
                  <MenuItemContent>
                    <LanguageFlag locale="ja" width={16} height={10} />
                    <span>日本語</span>
                  </MenuItemContent>
                </MenuItem>
                <MenuItem value="vi">
                  <MenuItemContent>
                    <LanguageFlag locale="vi" width={16} height={10} />
                    <span>Tiếng Việt</span>
                  </MenuItemContent>
                </MenuItem>
                <MenuItem value="es">
                  <MenuItemContent>
                    <LanguageFlag locale="es" width={16} height={10} />
                    <span>Español</span>
                  </MenuItemContent>
                </MenuItem>
              </LanguageSelectMUI>
                </LanguageSelectFormControl>
              </LanguageSelectWrapper>
            )}

            {/* 로그인 정보 */}
            <HeaderUser
              onNext={handleClick}
              isControlPage
              systemSetting={systemSetting("admin")}
            />

            {/* 로그아웃 */}
            <IconWrapper2 onClick={hadleLogout}>
              <LogOutIcon width={24} height={24} />
            </IconWrapper2>
          </OptionWrapper>

          {/* 햄버거 버튼 */}
          <button onClick={handleOnClick}>
            <MenuButton width="20px" height="20px" active={activeMenu} />
          </button>
        </div>

        <NavMenuContainerSM activeMenu={activeMenu}>
          <div
            style={{
              width: "100vw",
              height: "100vh",
              position: "fixed",
              left: 0,
              top: 0,
              zIndex: "-1",
              display: activeMenu ? "block" : "none",
            }}
            onClick={() => setActiveMenu(false)}
          ></div>
          <NavMenu
            isActive={["/"/*"/control"*/].includes(location.pathname)}
            onClick={() => navigateTo("/"/*"/control"*/)}
          >
            <TracktorIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>{t.navigation.accidentControl}</NavTextM>
          </NavMenu>

          {/* <NavMenu
            isActive={["/control/past"].includes(location.pathname)}
            onClick={() => navigateTo("/control/past")}
          >
            <DetectPastIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>과거 감지내역 조회</NavTextM>
          </NavMenu> */}

          <NavMenu
            isActive={location.pathname.includes("/detect-list")}
            onClick={() => navigateTo("/detect-list")}
          >
            <DetectListIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>{t.navigation.detectionHistory}</NavTextM>
          </NavMenu>

          <NavMenu
            isActive={location.pathname.includes("/mobile-list")}
            emptyCircle={true}
            onClick={() => navigateTo("/mobile-list")}
          >
            <TracktorAndGlassIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>{t.navigation.farmMachineryManagement}</NavTextM>
          </NavMenu>

          <NavMenu
            isActive={location.pathname.includes("/stastics")}
            onClick={() => navigateTo("/stastics")}
          >
            <DataPieIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            {/* <NavTextM>감지내역 통계</NavTextM> */}
            <NavTextM>{t.navigation.statistics}</NavTextM>
          </NavMenu>

          <NavMenu
            isActive={location.pathname.includes("/notice")}
            onClick={() => navigateTo("/notice")}
          >
            <NoticeIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>
              {t.navigation.notice}
              {newNoticeData && newNoticeData.list.length > 0 && (
                <NotificationBadge
                  width={"5px"}
                  height={"5px"}
                  top={"-5px"}
                  right={"25px"}
                />
              )}
            </NavTextM>
          </NavMenu>
          {user?.area === "00000" && user?.grade === 2 && (
            <NavMenu
              isActive={location.pathname.includes("/admin")}
              onClick={() => navigateTo("/admin")}
            >
              <SmallRealAdminIcon
                width={30}
                height={30}
                fill={theme.color.neutral_500}
              />
              <NavTextM>{t.navigation.userAccountManagement}</NavTextM>
            </NavMenu>
          )}
          <NavMenu
            isActive={location.pathname.includes("/customer")}
            onClick={() => navigateTo("/customer")}
          >
            <SmallAdminIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>{t.navigation.ownerManagement}</NavTextM>
          </NavMenu>
          <NavMenu
            isActive={location.pathname.includes("/nok")}
            onClick={() => navigateTo("/nok")}
          >
            <SmallNokIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>{t.navigation.additionalRecipientManagement}</NavTextM>
          </NavMenu>
          <NavMenu
            isActive={location.pathname.includes("/bigdata")}
            onClick={() => navigateTo("/bigdata")}
          >
            <BigDataIcon
              width={30}
              height={30}
              fill={theme.color.neutral_500}
            />
            <NavTextM>{t.navigation.bigdata}</NavTextM>
          </NavMenu>
          {user?.area === "00000" && user?.grade === 2 && (
            <>
              <NavMenu
                isActive={location.pathname === "/shop-zone"}
                onClick={() => navigateTo("/shop-zone")}
              >
                <ShopZoneIcon
                  width={30}
                  height={30}
                  fill={theme.color.neutral_500}
                />
                <NavTextM>{t.navigation.shopZoneMap}</NavTextM>
              </NavMenu>
              <NavMenu
                isActive={location.pathname.startsWith("/shop-zone/alarms")}
                onClick={() => navigateTo("/shop-zone/alarms")}
              >
                <DetectListIcon
                  width={30}
                  height={30}
                  fill={theme.color.neutral_500}
                />
                <NavTextM>{t.navigation.shopZoneAlarms}</NavTextM>
              </NavMenu>
            </>
          )}
        </NavMenuContainerSM>
      </MenuButtonContainer>

      {/* 마이페이지 모달 */}
      <UserDetailModal
        idx={idx}
        open={open}
        onPressNo={userModalonPressNo}
        setDetailData={setDetailData}
        onClickModify={onClickModify}
        isMyPage={true}
        systemSetting={systemSetting("admin")}
      />
      {/* 정보수정하기 모달 */}
      <UserModifyModal
        open={openModify}
        data={detailData}
        idx={idx}
        onPressNo={onPressNoModify}
        isMyPage={true}
        systemSetting={systemSetting("admin")}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media (max-width: ${md}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    min-width: 320px;
    height: 50px;
    /* background-color: ${theme.color.neutral_50}; */
    background-color: ${theme.color.white};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
    padding: 0 16px;
  }
`;

const LogoWrapper = styled.button`
  padding-top: 27px;
  padding-bottom: 27px;
  cursor: pointer;
  img {
    display: block;
    margin: 0 auto;
  }

  @media (max-width: ${sm}px) {
    padding: 0px;
    padding-left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
    }
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    padding: 0px;
    padding-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
    }
  }
`;

const NavMenu = styled.button<{
  isActive: boolean;
  emptyCircle?: boolean;
}>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding-top: 17px;
  padding-bottom: 17px;
  transition: 200ms;
  background-color: ${({ isActive }) =>
    isActive ? theme.statusColor.MAIN : theme.color.neutral_50};
  span {
    color: ${({ isActive }) =>
      isActive ? theme.color.white : theme.color.neutral_500};
  }
  svg {
    path {
      fill: ${({ isActive }) =>
        isActive ? theme.color.white : theme.color.neutral_500};
    }
    circle {
      fill: ${({ emptyCircle, isActive }) =>
        emptyCircle || isActive
          ? theme.color.white
          : theme.color.neutral_500};
    }
  }
  &:hover {
    span {
      color: ${({ isActive }) =>
        isActive ? theme.color.white : theme.statusColor.MAIN};
    }
    svg {
      path {
        fill: ${({ isActive }) =>
          isActive ? theme.color.white : theme.statusColor.MAIN};
      }
    }
    svg {
      circle {
        fill: ${({ emptyCircle, isActive }) =>
          emptyCircle || isActive
            ? theme.color.white
            : theme.statusColor.MAIN};
      }
    }
  }
  @media (max-width: ${md}px) {
    flex-direction: row;
    width: 200px;
    height: 50px;
    padding: 12px;
    gap: 10px;
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-height: 900px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  @media (min-width: ${md + 1}px) {
    &:hover {
      span {
        height: 12px;
        margin-top: 10px;
      }
    }
  }
`;

const NavTextM = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  margin-top: 10px;
  color: ${theme.color.neutral_500};
  position: relative;

  @media (max-width: ${md}px) {
    font-size: 12px;
    flex-grow: 1;
    margin-top: 0;
  }
`;

const NavMenuContainerSM = styled.div<{ activeMenu?: boolean }>`
  @media (max-width: ${md}px) {
    position: absolute;
    top: 50px;
    left: calc(100vw - 200px);
    overflow: hidden;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
    transition: 200ms;
    max-height: ${({ activeMenu }) => (activeMenu ? `500px` : `0px`)};
    z-index: ${theme.zindex.verticalNav};
  }
`;

const MenuButtonContainer = styled.div`
  @media (max-width: ${md}px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 5px;
    height: 50px;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: flex-end;

  @media (max-width: ${md}px) {
    flex-direction: row;
    gap: 8px;
    height: 50px;
  }
  svg {
    flex-shrink: 0;
  }
`;

const LanguageSelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 5px;
`;

const LanguageSelectFormControl = styled(FormControl)`
  && {
    min-width: 45px;
  }
`;

const LanguageSelectDisplay = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 2;
`;

const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const LanguageSelectMUI = styled(Select<Locale>)`
  && {
    height: 24px;
    
    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.color.neutral_300};
      border-radius: 4px;
    }
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.color.neutral_400};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.statusColor.MAIN};
    }
    
    .MuiSelect-select {
      padding-left: 28px !important;
    }
  }
`;

const IconWrapper2 = styled.button`
  cursor: pointer;
  display: flex;
  gap: 7px;
  padding-top: 20px;
  padding-bottom: 10px;
  &:hover span {
    color: ${theme.statusColor.MAIN};
  }
  &:hover svg path {
    fill: ${theme.statusColor.MAIN};
  }
  @media (max-width: ${md}px) {
    padding: 0;
  }
`;
